import { KYMW1100Model } from '../kymw1100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 旧商品タグ情報を取得するクラス
 *
 * @export GetOldGoodsTagListService
 * @class GetOldGoodsTagListService
 * @extends {PlessResponder}
 */
@Injectable()
export class GetOldGoodsTagListService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1100Model;
  private pCode: string;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetOldGoodsTagListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.pCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetOldGoodsTagListService
   */
  execute(model: KYMW1100Model, pCode: string, successFunc: Function = null): void {
    this.model = model;
    this.pCode = pCode;
    this.successFunc = successFunc;
    this.send('getOldGoodsTagList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetOldGoodsTagListService
   */
  success(data: any): void {
    this.model.setTagInfo(data);
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
